export default {
  title: 'Mode occupé',
  form: {
    has_busy_mode: {
      label: 'Mode occupé',
    },
    busy_mode_minutes: {
      label: 'Combien de temps ajouter à votre temps de préparation habituel ?',
      options: {
        10: '10 min',
        15: '15 min',
        20: '20 min',
        25: '25 min',
        30: '30 min',
        45: '45 min',
        60: '1 heure',
      },
    },
  },
  buttons: {
    save: 'Enregistrer',
  },
  toasts: {
    failed_to_save_changes: "Impossible d'enregistrer les modifications",
    changes_got_saved: 'Modifications enregistrées',
  },
};
